import type { Slicers } from 'types/services';
import { SLICER_KEYS } from 'types/services';

export const selectDrawer = () => (state: Slicers) => {
  return state[SLICER_KEYS.DRAWER_STATE];
};

export const selectFilters = (type: string) => (state: Slicers) => {
  return state[SLICER_KEYS.DRAWER_STATE].appliedFilters?.[type];
};

export const selectFiltersToApply = () => (state: Slicers) => {
  return state[SLICER_KEYS.DRAWER_STATE].filtersToApply;
};

export const selectFiltersAgendaId = () => (state: Slicers) => {
  return state[SLICER_KEYS.DRAWER_STATE].agendaId;
};
